export default "__VITE_ASSET__38992ae4__"